const formSelector = 'form[data-formie-form]'
const loadingDelay = 120
const minimumVisibleTime = 260

const getForms = (scope = document) => {
    if (scope.matches?.(formSelector)) {
        return [scope]
    }

    return Array.from(scope.querySelectorAll(formSelector))
}

const setButtonsDisabled = (form, isDisabled) => {
    form.querySelectorAll('[type="submit"], [data-formie-action]').forEach((button) => {
        if (isDisabled) {
            if (!button.disabled) {
                button.dataset.formieLoadingDisabled = 'true'
                button.disabled = true
            }

            return
        }

        if (button.dataset.formieLoadingDisabled === 'true') {
            button.disabled = false
            delete button.dataset.formieLoadingDisabled
        }
    })
}

// The step holding the upload field blocks on a Claude image analysis that takes several
// seconds, so it gets an explanatory panel instead of a bare spinner. Detected from the DOM
// rather than a page marker, so it keeps working if the field ever moves to another step.
const isAnalysisStep = (form) => {
    const currentPage = form.querySelector(
        '[data-formie-page]:not([data-formie-page-hidden])'
    )

    return !!currentPage?.querySelector('[data-formie-upload-manager-root]')
}

const setAnalysisPanelVisible = (form, isVisible) => {
    const panel = form.querySelector('[data-request-loading-panel]')

    if (panel) {
        panel.hidden = !isVisible
    }
}

const setLoading = (form, isLoading, message = '') => {
    const overlay = form.querySelector('[data-request-loading]')
    const messageTarget = form.querySelector('[data-request-loading-message]')

    if (!overlay) {
        return
    }

    if (!isLoading) {
        setAnalysisPanelVisible(form, false)
    }

    window.clearTimeout(form.formieLoadingTimer)

    if (isLoading) {
        form.dataset.requestLoading = 'true'
        form.formieLoadingStartedAt = Date.now()
        setButtonsDisabled(form, true)

        if (messageTarget && message) {
            messageTarget.textContent = message
        }

        return
    }

    const elapsed = Date.now() - (form.formieLoadingStartedAt || 0)
    const remaining = Math.max(minimumVisibleTime - elapsed, 0)

    form.formieLoadingTimer = window.setTimeout(() => {
        delete form.dataset.requestLoading
        setButtonsDisabled(form, false)
    }, remaining)
}

const initForm = (form) => {
    if (form.dataset.formieLoadingReady === 'true') {
        return
    }

    form.dataset.formieLoadingReady = 'true'

    form.addEventListener('formie:submit:before', () => {
        setAnalysisPanelVisible(form, isAnalysisStep(form))
        setLoading(form, true, 'Even geduld')
    })

    form.addEventListener('formie:stage:validate:after', (event) => {
        window.setTimeout(() => {
            if (event.defaultPrevented || event.detail?.result?.ok === false) {
                setLoading(form, false)
            }
        }, 0)
    })

    // Fires for both success and failure. Mirrors Formie's own "keep loading"
    // predicate: stay spinning while the browser is on its way to a redirect.
    form.addEventListener('formie:submit:result', (event) => {
        const result = event.detail

        const keepLoading =
            result?.keepSubmitLoading === true ||
            (result?.ok &&
                result?.redirect?.url &&
                result?.redirect?.target !== 'new-tab')

        if (!keepLoading) {
            setLoading(form, false)
        }
    })

    form.addEventListener('formie:page:navigate:after', () => {
        setLoading(form, true, 'Laden')

        window.setTimeout(() => {
            setLoading(form, false)
        }, loadingDelay)
    })
}

export const initFormieLoading = (scope = document) => {
    getForms(scope).forEach(initForm)
}
